<template>
    <div class="ml-2">
        <b-button variant="success" @click.stop="abrirModal()"
            ><i class="fa fa-paper-plane"></i> Enviar</b-button
        >
        <encaminhamento-form
            titulo="Enviar Requisição"
            operacao="E"
            :dados="dadosEnvio"
            :requisicao="requisicao"
            :erros="erros"
            :mostrarModal="mostrarModal"
            @fecharModal="fecharModal()"
            @salvar="enviarRequisicao($event)"
        ></encaminhamento-form>
    </div>
</template>

<script>
import EncaminhamentoForm from './EncaminhamentoForm'
import RequisicoesServicos from './RequisicoesServicos'

export default {
    props: {
        requisicao: {
            type: Object
        }
    },

    components: {
        EncaminhamentoForm
    },

    data() {
        return {
            erros: [],
            mostrarModal: false,
            dadosEnvio: null
        }
    },

    methods: {
        fecharModal() {
            this.mostrarModal = false
        },

        abrirModal() {
            this.obterDadosEnvio()
        },

        obterDadosEnvio() {
            this.$store.dispatch('addRequest')
            RequisicoesServicos.obterDadosEnvio(
                this.$route.params.idRequisicao
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.dadosEnvio = response.data
                    } else {
                        this.erros = [
                            'Erro ao obter dados para envio da requisição'
                        ]
                    }
                }
                this.$store.dispatch('removeRequest')
                this.mostrarModal = true
            })
        },

        enviarRequisicao(envio) {
            this.$store.dispatch('addRequest')
            envio.idRequisicao = this.requisicao.idRequisicao
            RequisicoesServicos.enviar(envio).then(response => {
                if (response) {
                    if (response.success) {
                        this.$emit('obterRequisicaoAtualizada')
                        this.$store.dispatch('setRecarregar', true)
                        this.$toast.success(
                            'Requisição enviada com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.mostrarModal = false
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    computed: {},

    created() {}
}
</script>
